import React, { PropsWithChildren } from 'react';
import { identifyComponent } from '../../util';
import { Select, SelectProps } from '../Select';

export const SelectMenuSelect: React.FC<PropsWithChildren<SelectProps>> = ({
  children,
  open,
  ...rest
}) => (
  <Select
    data-component="SelectMenuSelect"
    open={open}
    {...rest}
    {...identifyComponent('select-menu-select', rest)}
  >
    {children}
  </Select>
);
